import _ from 'lodash';
import { create } from '@patsnap/tahiti-core';
import type { Account } from '@patsnap-utils/biz';
import type Passport from '@patsnap-utils/passport/src/passport';

const isNeedSentry = ['qa', 'stage', 'cn', 'us', 'eu'].includes(import.meta.env.VITE_DEPLOY_ENV as string);
export const productShellDeferred = create<() => void>();
export const accountDeferred = create<Account>();
export const prepareTokenDeferred = create<Passport>();
function loadThirdPartyTools(account: Account, locale: string, projectName: string) {
    if (import.meta.env.DEV) {
        console.info('%c开发环境禁用第三方工具', 'color: red');
        return;
    }

    import(/* webpackChunkName: "third-party" */'./backoffice-widget')
        .then(({ loadBackofficeWidget }) => loadBackofficeWidget(locale));

    // @ts-ignore
    if (_.isObject(window.newrelic)) {
        // @ts-ignore
        window.newrelic?.addPageAction('init', {
            uid: _.get(account, '_info.account_id', ''),
            cid: _.get(account, '_info.company_id', ''),
        });
    }
    if (isNeedSentry) {
        import(/* webpackChunkName: "sentry" */'./sentry')
            .then(({ sentry }) => sentry(projectName, account));
    }
}


/**
 * 产品信息
 */
export interface ProjectInfo {
    /**
     * 项目名称
     */
    projectName: string;
}

export function defer(projectInfo: ProjectInfo, account: Account, locale: string) {
    const delay = 3000;
    const { projectName } = projectInfo;

    setTimeout(() => loadThirdPartyTools(account, locale, projectName), delay);
}
